export var black = '#000000';
export var white = '#FFFFFF';
//To overwrite MUI default greys
export var grey = {
    50: '',
    100: '#F7F9FA',
    120: '#EDEDED',
    150: '#ECF2F5',
    200: '#E9F1F6',
    300: '#DEDFE0',
    400: '',
    500: '#A0A7AB',
    600: '',
    700: '#696D6F',
    800: '#3A3C3D',
    900: '#1D1F20',
    A100: '',
    A200: '',
    A400: '',
    A700: '',
};
export var feedback = {
    destructive: '#F3676B',
    success: '#2EB67D',
};
